import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchCache, imageCache, setInCache } from '../../../utils/clearId8ImageCaches';
import sendRequest from '../../../service/sendRequest';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import CommonLoader from '../../../components/common-loader/CommonLoader';

import scss from './SourceImageModal.module.scss';

function SourceImage({ promptId, className, style, onGetImage }) {
  const { t } = useTranslation('id8');
  const [imageUrl, setImageUrl] = useState(null);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setImageUrl(null);
    setHasError(true);
  };

  useEffect(() => {
    if (!promptId) return;

    if (imageCache.has(promptId)) {
      setImageUrl(imageCache.get(promptId));
      return;
    }

    const cachedPromise = fetchCache.get(promptId);
    const fetchPromise =
      cachedPromise ||
      sendRequest(
        () => {
          return onGetImage(promptId);
        },
        {
          onError: () => {
            fetchCache.delete(promptId);
            setHasError(true);
          },
        },
      ).then((response) => {
        const blobUrl = URL.createObjectURL(new Blob([response.data]));
        setInCache(imageCache, promptId, blobUrl);
        return blobUrl;
      });

    setInCache(fetchCache, promptId, fetchPromise);
    fetchPromise.then((url) => {
      setImageUrl(url);
    });
  }, [promptId, onGetImage]);

  useEffect(() => {
    return () => {
      if (imageUrl && !Array.from(imageCache.values()).includes(imageUrl)) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [imageUrl]);

  if (!promptId) return null;
  if (hasError)
    return (
      <div className={scss.errorWrapper}>
        <Icon icon={ICONS.Logo} className={scss.errorIcon} />
        <span className={scss.errorText}>{t('errorOccurred')}</span>
      </div>
    );
  if (!imageUrl) return <CommonLoader isLoading={true} />;

  return (
    <img
      src={imageUrl}
      alt={'Source for recreated ad'}
      className={className}
      role='presentation'
      loading='lazy'
      onError={handleError}
      style={style}
    />
  );
}

export default SourceImage;
